import { LeftSidebarView } from 'components/Sidebar'
import React from 'react'
import DocumentList from './DocumentList'

const ModalDocumentList: React.FC<{
  documentSourceId: number;
  url?: string;
  title: React.ReactNode;
  path?: any[];
  sort?: string;
}> = ({
  documentSourceId,
  url,
  title,
  path,
  sort,
}) => {
  return (
    <LeftSidebarView
      title={title}
    >
      <DocumentList
        documentSourceId={documentSourceId}
        url={url}
        title={title}
        defaultPath={path}
        defaultSort={sort}
      />
    </LeftSidebarView>
  )
}

export default ModalDocumentList
